/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Page from "components/common_components/Page/Page";
import Form from "./Form";
import { useDispatch } from "react-redux";
import { notifySuccess, notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Icon from "components/common_components/Icon";
import Button from "components/common_components/Button";
import SettingsContext from "components/Settings/SettingsContext";

const headCells = [
    { index: 1, id: "id", label: "Identifier" },
    { index: 2, id: "category", label: "Category" },
    { index: 3, id: "description", label: "Description" },
    { index: 4, id: "parentCategory.category", label: "Parent Category" },
];

function Categories(props) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [mode, setMode] = useState("listOnly");
    const [itemToEdit, setItemToEdit] = useState(undefined);
    const [pageableData, setPageableData] = useState(undefined);
    const [resources, setResources] = useState({
        categories: [],
    });

    const {
        Forms: { Categories },
    } = useContext(SettingsContext);

    function getCategories(requestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Categories.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    const getResources = () => {
        setIsLoading(true);
        Categories.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    categories: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    categories: [],
                }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        getCategories();
        getResources();

        return () => {
            setData([]);
            setResources((prev) => ({
                ...prev,
                categories: [],
            }));
            setItemToEdit(undefined);
        };
    }, []);

    function onRowClickHandler(item) {
        setItemToEdit(item);
        setMode("update");
    }

    function onCancelHandler() {
        setItemToEdit(undefined);
        setMode("listOnly");
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        onCancelHandler();
        dispatch(notifySuccess(`Category ${mode === "add" ? "created" : "updated"} successfully!`));
        getCategories();
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { id, ...payload } = values;

        const apiCall = mode === "add" ? Categories.add : Categories.update;

        apiCall({
            payload: { id: id.trim().toUpperCase(), ...payload },
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getCategories();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Categories.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  id: filterValue,
                  category: filterValue,
                  description: filterValue,
              }
            : {};
    }

    function onAddHandler() {
        setItemToEdit(undefined);
        setMode("add");
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {mode !== "listOnly" && (
                        <Form
                            data={itemToEdit}
                            mode={mode}
                            resources={resources}
                            onSubmit={onSubmitHandler}
                            onCancel={onCancelHandler}
                            title={mode === "add" ? "New Category" : "Update Category"}
                        />
                    )}
                    {mode === "listOnly" && (
                        <>
                            <Button primary onClick={onAddHandler}>
                                <Icon name="add" size="md" color="white" />
                                <span>Add</span>
                            </Button>
                            <EnhancedTable
                                headCells={headCells}
                                data={data}
                                defaultOrder={{
                                    order: "asc",
                                    orderBy: "id",
                                }}
                                selectable
                                keyColumnName="id"
                                onRowClick={onRowClickHandler}
                                onDelete={onDeleteHandler}
                                onRequestData={getCategories}
                                filterBuilder={filterBuilder}
                                pageableData={pageableData}
                                defaultRowsPerPage={50}
                            />
                        </>
                    )}
                </>
            )}
        </Page>
    );
}

export default Categories;
